import { postRequestWithAuth } from '../api'

export interface ImageUploadResponse {
  image_id: string
  filename: string
}

export const uploadEditorImage = async (sessionId: string, file: File): Promise<ImageUploadResponse> => {
  const formData = new FormData()
  formData.append('session_id', sessionId)
  formData.append('file', file)

  const response = await postRequestWithAuth('/api/v1/editor/uploadImage', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
  
  return response
}

export const deleteEditorImage = async (sessionId: string, imageId: string): Promise<void> => {
  await postRequestWithAuth('/api/v1/editor/deleteImage', {
    session_id: sessionId,
    image_id: imageId,
  })
}